export default __webpack_public_path__ + "media/music/06f37a669bf4b18d03a13cca3f67599e.mp3";